import useUser from '@cobliteam/hooks/src/useEntity/useUser';
import { getToastTypes } from '../registry';

// Um slot por tipo de toast: só monta o controller (hook) do tipo, que assina o realtime do feed
// compartilhado e dispara o toast. Não renderiza nada.
const NotificationToastSlot = ({ useController }: { useController: () => void }) => {
  useController();
  return null;
};

/**
 * Surface genérica do toast: monta um slot por tipo registrado com `surfaces.toast`. Master gate = sessão
 * presente; cada tipo gateia internamente por flag. O feed do Knock saiu (AI-450).
 */
const NotificationToast = () => {
  const { getSession } = useUser();
  const userId = getSession()?.user?.id;

  if (!userId) return null;

  return (
    <>
      {getToastTypes().map((type) => (
        <NotificationToastSlot key={type.key} useController={type.useToastController!} />
      ))}
    </>
  );
};

export default NotificationToast;
